<template>
  <div class="myWork">
    <el-tabs v-model="tabActiveName" @tab-click="handleTabClick">
      <el-tab-pane v-for="item in tabList" :key="item.id" :label="item.label" :name="item.id">
        <div class="myWork_options" v-if="tabActiveName === '15'">
          <ul>
            <li @click="onOptionClick(item)" :class="{'is_option': categoryId === item.id}" v-for="item in tagList" :key="item.id">{{item.label}}</li>
          </ul>
        </div>
        <ul class="myWork_video" v-if="tabActiveName === '14' || categoryId === 0">
          <li @click="goVideoDetailsPage(item, 'videoIn')" v-for="item in contentList" :key="item.id">
            <img v-if="item.isVip === 1" class="vipicon"
                 src="@/assets/img/infoCollege/video_vip_icon.png" alt="icon">
            <div class="img_box">
              <img class="videoPic" :src="item.imgUrl" alt="视频封面">
            </div>
            <p>{{item.title}}</p>
            <i class="video_time">{{initVideoDuration(item.formattedDuration)}}分钟</i>
          </li>
        </ul>
        <ul class="myWork_ article" v-else>
          <li @click="goSelectedDocumentPage(item, 'videoIn')" v-for="item in contentList" :key="item.id">
            <div class="img_box">
              <img class="filePic" :src="item.imgUrl" alt="封面">
            </div>
            <p class="title">{{item.title}}</p>
            <div class="author">{{item.author}}</div>
          </li>
        </ul>
        <placeholder :isShow="contentList.length <= 0" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getPutInListByUserId } from '@/api/mySciencePopularization.js'
import { getImageFormat } from '@/utils/index.js'
export default {
  comments: {
  },
  data () {
    return {
      tabList: [{
        icon: '',
        label: '数字人科普视频',
        value: 'people',
        id: '14'
      }, {
        icon: '',
        label: '医医科普作品',
        value: 'doctor',
        id: '15'
      }],
      tabActiveName: '14',
      contentList: [],
      tagList: [
        {
          id: 0,
          label: '视频'
        }, {
          id: 1,
          label: '文章'
        }
      ],
      pageNum: 1,
      pageSize: 10,
      categoryId: 0
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    handleTabClick () {
      this.getPutInListByUserId()
    },
    // 分类选中
    onOptionClick (item) {
      this.categoryId = item.id
      this.getPutInListByUserId()
    },
    // 跳转到视频详情页
    goVideoDetailsPage (video, type) {
      if (!this.userInfo.userId) {
        return this.$login()
      }
      sessionStorage.setItem('videoObj', JSON.stringify({
        videoId: video.id,
        videoUrl: video[type],
        modularType: 'video',
        tabActive: 2,
        tabActiveName: this.tabActiveName
      }))
      this.$router.push('/videoDetails')
    },
    // 跳转详情页
    goSelectedDocumentPage (item, type) {
      if (item[type].indexOf('.pdf') !== -1 || item[type].indexOf(`.${getImageFormat(item[type])}`) !== -1) {
        return window.open(item[type])
      }
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${item[type]}`)
    },
    // 获取我的科普列表
    async getPutInListByUserId () {
      try {
        const { data } = await getPutInListByUserId({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          type: this.tabActiveName === '14' ? 0 : this.categoryId, // （类型0视频1文章）
          name: this.tabActiveName // 14-AIGC 15-医医科普
        })
        this.contentList = data
      } catch (error) {
        this.$message.error(error)
      }
    },
    initVideoDuration (duration) {
      if (!duration) return '-'
      return parseInt(duration.split(':')[1], 10)
    }
  },
  created () {
    this.getPutInListByUserId()
    this.tabActiveName = JSON.parse(window.sessionStorage.getItem('videoObj'))?.tabActiveName || '14'
  }
}
</script>
<style lang="less" scoped>
.myWork {
  /deep/.el-tabs__active-bar{
    width: 98px !important;
  }
  .el-tabs{
    /deep/.el-tabs__header{
      margin: 0;
    }
    /deep/.el-tabs__content{
      padding-top: 20px;
    }
  }
  .myWork_video {
    display: flex;
    flex-wrap: wrap;
    gap: 18.5px;
    li {
      position: relative;
      width: 23.5%;
      height: 250px;
      padding: 20px;
      background-color: #fff;
      border-radius: 5px;
      cursor: pointer;
      top: 0;
      transition: top 0.3s;
      &:hover {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        top: -5px;
        .videoPic {
          transform: scale(1.15);
        }
      }
      .vipicon {
        position: absolute;
        left: 20px;
        bottom: 5px;
        z-index: 90;
        height: 14px;
        border-radius: 0 2px 0 0;
      }
      .videoPic {
        width: 100%;
        transform: scale(1.01);
        transition: transform 0.4s;
      }
      .img_box {
        position: relative;
        width: 100%;
        overflow: hidden;
      }
      p {
        margin-top: 10px;
        line-height: 20px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .video_time {
        position: absolute;
        bottom: 8px;
        right: 10px;
        color: #9195a3;
        font-size: 12px;
      }
    }
  }
  .myWork_options {
    width: 100%;
    margin-bottom: 20px;
    border-radius: 0 0 2px 2px;
    ul {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      li {
        height: 30px;
        padding: 0 10px;
        line-height: 30px;
        text-align: center;
        color: #606266;
        background: #fff;
        border-radius: 2px;
        cursor: pointer;
        margin-right: 5px;
        &:hover {
          background-color: #e8ecf6;
          color: #4b639f;
        }
      }
      .is_option {
        background-color: #e8ecf6;
        color: #4b639f;
      }
    }
  }
  .myWork_ article {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    li {
      position: relative;
      display: flex;
      width: 23.38%;
      height: 120px;
      background-color: #fff;
      border-radius: 2px;
      padding: 20px;
      cursor: pointer;
      top: 0;
      transition: top 0.3s;
      &:hover {
        top: -5px;
        box-shadow: 4px 4px 10px rgba(204, 204, 204, 0.5),
          -2px -3px 7px #ffffff;
        transition: all 0.2s;
        .filePic {
          transform: scale(1.15);
        }
      }
      .filePic {
        width: 100%;
        transform: scale(1.01);
        transition: transform 0.4s;
      }
      .title {
        font-size: 14px;
        line-height: 20px;
        height: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .author {
        position: absolute;
        bottom: 5px;
        right: 10px;
        width: 80%;
        text-align: end;
        font-size: 12px;
        color: #9195a3;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .img_box {
        position: relative;
        width: 106px;
        height: 100%;
        flex-shrink: 0;
        margin-right: 10px;
        overflow: hidden;
      }
    }
  }
  .btn_box {
    width: 100%;
    text-align: center;
    span {
      display: inline-block;
      padding-bottom: 20px;
      font-size: 14px;
      cursor: pointer;
      color: #4b639f;
      &:hover {
        font-weight: 600;
      }
    }
  }
}
</style>
